
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen relative">
      {/* 3D Globe Background for entire page */}
      <div className="fixed inset-0 z-0">
        <iframe 
          src='https://my.spline.design/3dglobe-p3XQBgXXJW2L7fmP5LlHN6Xc/' 
          frameBorder='0' 
          width='100%' 
          height='100%'
          className="w-full h-full"
        />
      </div>
      
      {/* Overlay for better content readability */}
      <div className="fixed inset-0 bg-black/40 z-10"></div>
      
      {/* All page content */}
      <div className="relative z-20">
        {/* Hero Section */}
        <section className="py-20 pt-32">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 drop-shadow-2xl">
                About Our Company
              </h1>
              <p className="text-xl text-white/90 max-w-4xl mx-auto leading-relaxed drop-shadow-lg">
                Discover what makes us the world's most unique all-around digital partner
              </p>
            </div>
          </div>
        </section>

        {/* Why Choose Our Integrated Approach Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-4xl font-bold text-white mb-8 drop-shadow-2xl">Why Choose Our Integrated Approach?</h2>
                <div className="space-y-6">
                  <p className="text-lg text-white/90 leading-relaxed drop-shadow-lg">
                    We stand apart as the world's most unique all-around company, serving as a one-stop shop for cutting-edge digital partnerships. Unlike specialized agencies that focus on singular domains, we provide a cohesive ecosystem of integrated services that work in harmony to accelerate your growth.
                  </p>
                  <p className="text-lg text-white/90 leading-relaxed drop-shadow-lg">
                    Our cross-functional expertise ensures that your marketing strategies are supported by robust security protocols, your customer communications are enhanced by AI-powered insights, and your financial operations are streamlined through customized platforms.
                  </p>
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/58dc8b818501ad711f9d056bff95b975.jpg"
                  alt="Integrated digital approach"
                  className="rounded-2xl shadow-2xl object-cover w-full h-96 border border-white/20"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Key Benefits */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h3 className="text-3xl font-bold text-white mb-6 drop-shadow-2xl">Our Integrated Advantage</h3>
              <p className="text-xl text-white/90 drop-shadow-lg">Experience the power of unified digital solutions</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center shadow-2xl border border-white/20">
                <div className="w-20 h-20 bg-blue-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-blue-300/30">
                  <i className="ri-shield-check-line text-3xl text-blue-300"></i>
                </div>
                <h4 className="text-xl font-bold text-white mb-4 drop-shadow-lg">Security-First Marketing</h4>
                <p className="text-white/80 drop-shadow-md">Marketing strategies backed by enterprise-grade security protocols</p>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center shadow-2xl border border-white/20">
                <div className="w-20 h-20 bg-purple-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-purple-300/30">
                  <i className="ri-brain-line text-3xl text-purple-300"></i>
                </div>
                <h4 className="text-xl font-bold text-white mb-4 drop-shadow-lg">AI-Enhanced Communications</h4>
                <p className="text-white/80 drop-shadow-md">Customer interactions powered by intelligent insights and automation</p>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center shadow-2xl border border-white/20">
                <div className="w-20 h-20 bg-green-500/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6 border border-green-300/30">
                  <i className="ri-line-chart-line text-3xl text-green-300"></i>
                </div>
                <h4 className="text-xl font-bold text-white mb-4 drop-shadow-lg">Streamlined Operations</h4>
                <p className="text-white/80 drop-shadow-md">Financial and operational systems optimized for maximum efficiency</p>
              </div>
            </div>
          </div>
        </section>

        {/* Get Started Today Section */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto text-center px-6">
            <h2 className="text-4xl font-bold text-white mb-6 drop-shadow-2xl">
              Get Started Today
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed drop-shadow-lg">
              Ready to transform your digital presence and achieve unprecedented growth? Our team of experts is prepared to develop tailored solutions that address your unique business challenges and objectives.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact" 
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-2xl whitespace-nowrap cursor-pointer inline-block"
              >
                Start Your Transformation
              </Link>
              <Link 
                to="/services" 
                className="bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all duration-300 border border-white/20 whitespace-nowrap cursor-pointer inline-block"
              >
                Explore Our Services
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
